// extracted by mini-css-extract-plugin
export default {"container":"Gallery_container__voWsM","title":"Gallery_title__Q9ILM","gallery":"Gallery_gallery__TFBMk"};